import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsLastDotFmComponent } from './simple-icons-last-dot-fm.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsLastDotFmComponent ],
    exports:      [ SimpleIconsLastDotFmComponent ],
    bootstrap:    []
})
export class SimpleIconsLastDotFmModule {}
